import React, { memo, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import API from 'api';
import Ad from 'models/business/Ad';
import Market from 'models/business/Market';
import Asset from 'models/business/Asset';
import HeaderTypography from '../../Common/HeaderTypography';
import TopUpCard from '../../Common/TopUpCard';
import MarketDashboard from './MarketDashboard';
import AdDashboard from './AdDashboard';
import Styles from './index.module.css';

function MyAds() {
  const [markets, setMarkets] = useState([]);
  const [ads, setAds] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [amounts, setAmounts] = useState(JSON.parse(localStorage.getItem('amounts')));
  const history = useHistory();

  const fetchMarketAssets = async (id) => {
    const result = await API.mall.getMallAssets(id);
    if (result.error) {
      alert(result.error.errorMsg);
      return null;
    }

    return (result.resultData || []).map((a) => new Asset(a))[0];
  };

  const fetchMarkets = async () => {
    const result = await API.mall.getMallList();
    if (result.error) {
      alert(result.error.errorMsg);
      return [[], result.error];
    }
    // eslint-disable-next-line max-len
    return [(result.resultData || []).map((ad) => new Market(ad))];
  };

  const fetchAds = async () => {
    const result = await API.ad.postAdList();
    if (result.error) {
      alert(result.error.errorMsg);
      return [[], result.error];
    }
    return [(result.resultData || []).map((ad) => new Ad(ad))];
  };

  const load = async () => {
    const [newMarkets, marketError] = await fetchMarkets();
    const marketLookup = newMarkets.reduce((ms, m) => ({ ...ms, [m.id]: m }), {});
    const [newAds, adError] = await fetchAds();
    const marketAssetLookup = [];
    for (let i = 0; i < newMarkets.length; i += 1) {
      // eslint-disable-next-line no-await-in-loop
      const asset = await fetchMarketAssets(newMarkets[i].id);
      if (asset) marketAssetLookup[newMarkets[i].id] = asset;
    }
    newAds.forEach((ad) => {
      ad.injectMarket(marketLookup[ad.marketId]);
      // eslint-disable-next-line no-param-reassign
      ad.marketContentFeedId = marketAssetLookup[ad.marketId]?.id || '';
    });
    setMarkets(newMarkets);
    setAds(newAds);
    return {
      markets: newMarkets,
      ads: newAds,
      error: marketError || adError,
    };
  };

  useEffect(() => {
    load().then(({ markets: newMarkets, error }) => {
      if (!error && !newMarkets.length) {
        alert('請新增賣場再繼續');
        history.push('/MarketSetting');
      }
    });
  }, []);

  return (
    <div className={Styles.myAdsWrapper}>
      <div className={Styles.myAdsBody}>
        <div className={Styles.title}>
          <HeaderTypography>
            儲值狀態
          </HeaderTypography>
        </div>
        <div className={Styles.dashboard}>
          <TopUpCard />
        </div>
        <div className={Styles.title} style={{ marginBottom: '8px' }}>
          <HeaderTypography>
            廣告總覽
          </HeaderTypography>
        </div>
        <div className={Styles.dashboard}>
          <AdDashboard ads={ads} amounts={amounts} />
        </div>
      </div>
      <div className={Styles.myAdsSide}>
        <MarketDashboard onChangeMarkets={load} markets={markets} />
      </div>
    </div>
  );
}

export default memo(MyAds);
